import { useMutation, useQueryClient } from "@tanstack/react-query";

import toast from "react-hot-toast";
import { deleteLectureQuizQuesion as deleteLectureQuizQuesionApi } from "../../../../services/dashboard/apiQuizes";

export function useDeleteQuizQuestion() {
  const queryClient = useQueryClient();

  const {
    mutate: deleteQuizQuestion,
    isLoading: isDeleting,
    error,
  } = useMutation({
    mutationFn: deleteLectureQuizQuesionApi,
    onSuccess: () => {
      toast.success("تم حذف السؤال بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["quizQuestionsDB"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { deleteQuizQuestion, isDeleting, error };
}
